import React from 'react';
import PolicyPage from '../components/PolicyPage';

export default function FCOI() {
  return <PolicyPage policy="fcoi" />;
}
